/** @format */

import { styled } from "@mui/material/styles";
import Page from "../../components/Page";
import { Container, Stack, Typography } from "@mui/material";

import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

import logo from "../../static/logo-infomedia.png"; // relative path to image
import email from "../../assets/mail.png";

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  display: "flex",

  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
}));

export default function ConfirmEmail() {
  const navigate = useNavigate();
  const location = useLocation();

  const [count, setCount] = useState(10);

  useEffect(() => {
    if (count > 0) {
      const interval = setInterval(() => {
        setCount((count) => count - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
    if (count === 0) {
      navigate("/login");
    }
  }, [count, navigate]);

  return (
    <RootStyle title="confirmation email">
      <Container maxWidth="sm">
        <ContentStyle>
          <Stack spacing={3} justifyContent={"center"} alignItems={"center"}>
            <img src={logo} style={{ width: "350px" }} alt="logo-infomedia" />
            <Typography fontWeight={"600"}>Verify your email</Typography>
            <img src={email} style={{ width: "150px" }} alt="logo-email" />
            <Typography fontWeight={"600"} textAlign={"center"}>
              Email has been sent to {location?.state}. Please Verify & Create
              Password in Your Inbox
            </Typography>
            <Typography fontWeight={"600"} textAlign={"center"}>
              Will redirect to{" "}
              <span
                onClick={() => navigate("/login")}
                style={{ color: "blue", cursor: "pointer", fontWeight: "700" }}
              >
                Login
              </span>{" "}
              page at {count} seconds
            </Typography>
          </Stack>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
